import { Injectable } from '@angular/core';
import * as moment from 'moment';

@Injectable({ providedIn: 'root' })
export class DatepickerUtilsService {

	getTimeString(date: Date | string): string {
		return moment(date).format('HH:mm');
	}

	getDateString(date: Date | string, withHours = false): string {
		return moment(date).format(withHours ? 'MM/DD/YYYY HH:mm' : 'MM/DD/YYYY');
	}

	parseDate(value: string): Date {
		const m = moment(value, 'MM/DD/YYYY HH:mm', true);
		return m.isValid() ? m.toDate() : null;
	}

	getDate(value: unknown): Date | null {
		if (!value) return null;
		const m = moment(value);
		return m.isValid() ? m.toDate() : null;
	}

	mergeDateTime(date: Date, time: Date): Date {
		let datepicker = moment(date);
		let timepicker = moment(time);
		let m = moment();
		m.set({ year: datepicker.year(), month: datepicker.month(), date: datepicker.date(), hour: timepicker.hour(), minute: timepicker.minute(), second: 0, millisecond: 0 });
		return m.toDate();
	}
}
